import './ListSort.scss';

import cn from 'classnames';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/common/components/atoms/Button/Button';
import { ASC, DESC } from '@/common/constants';
import formatKey2CamelCase from '@/common/helpers/formatKey2CamelCase';
import { ReactComponent as SortIcon } from '@/materiaux/assets/icons/arrow-light-bottom.svg';

import { ListSortDefaultProps, ListSortPropTypes } from './ListSort.proptypes';

const ListSort = ({
  className,
  context,
  disabled,
  dynamicOptions,
  handleSort,
  isLoading,
  showNetPrice,
  staticOptions,
}) => {
  const { t } = useTranslation();

  /**
   * Merge static and dynamic sort options and set sortable = true for dynamic sort items
   * @type {array}
   */
  const sorting = useMemo(
    () =>
      staticOptions.map((item) => {
        const sortIndex = dynamicOptions.findIndex(
          (sort) => sort.code === item.code,
        );

        if (sortIndex >= 0) {
          return { ...item, ...dynamicOptions[sortIndex], sortable: true };
        }

        return item;
      }),
    [dynamicOptions, staticOptions],
  );

  if (sorting) {
    return (
      <ul
        className={cn('list-sort', className, {
          'products__list-sort--show-net-price': showNetPrice,
        })}
        data-qa-id={context || 'list-sort'}
      >
        {sorting.map((sort) => (
          <li
            className={cn(
              `list-sort__${formatKey2CamelCase(sort.code)}`,
              'sort',
              {
                [`sort--${sort.direction}`]: sort.direction,
              },
            )}
            data-qa-id="list-sort-item"
            key={`list-${sort.code}`}
          >
            <Button
              className="sort__button"
              context={`button-${sort.code}`}
              disabled={
                !sort.sortable || disabled || isLoading || sort.disabled
              }
              onClick={() =>
                handleSort(sort.code, sort.direction === ASC ? DESC : ASC)
              }
              title={sort.label}
              value={sort.code}
            >
              {t(sort.label)}
              {sort.sortable && <SortIcon className="sort__icon" />}
            </Button>
          </li>
        ))}
      </ul>
    );
  }

  return null;
};

ListSort.defaultProps = {
  ...ListSortDefaultProps,
};

ListSort.propTypes = {
  ...ListSortPropTypes,
};

export default ListSort;
